<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Recuperar Contraseña</h4>
                                    <p>Ingrese su dirección de correo electrónico y le enviaremos instrucciones sobre cómo restablecer su contraseña.</p>
                                </div>

                                <vs-input
                                    v-validate="'required|email'"
                                    data-vv-validate-on="blur"
                                    name="Correo"
                                    type="email"
                                    label-placeholder="Correo"
                                    placeholder="Correo"
                                    v-model="email"
                                    class="w-full mt-6"
                                />
                                <span class="text-danger text-sm">{{ errors.first('Correo') }}</span>
                                <vs-divider></vs-divider>
                                <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">Inicar sesión</vs-button>
                                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" @click="recoverPassword">Recuperar Contraseña</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      email: ''
    }
  },
  computed: {
    validateForm () {
      return this.email !== '';
    }
  },
  methods: {
    recoverPassword (){
        if(this.validateForm) {
            const payload = {   
                email: this.email,
            }
            this.$store.dispatch('auth/sendPasswordRecoveryEmail', payload).then(() => {
                this.$router.push('/pages/login').catch(() => {})
            })
        }    
    }
  }
}
</script>
